import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';

function UpgradeSuccessModal() {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <Modal
      title={<h3 className="font-gilroy font-semibold text-xl text-green"> {t("Success!")} </h3>}
      subtitle={t("You have successfully upgraded your Portant subscription")}
      primaryButtonProps={{ text: t("Close"), onClick: closeModal }}
      size='sm'
    />
  );
}

export default UpgradeSuccessModal;
